module.exports = __webpack_public_path__ + "img/loginlogo2.9f0cf13f.png";